var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      ref: "modal",
      attrs: {
        title: _vm.$t("influencer_panel.info_title"),
        "ok-only": true,
        "ok-title": _vm.$t("action.close"),
        "ok-variant": "outline-secondary",
        size: "lg",
      },
      on: { hidden: _vm.reset },
    },
    [
      _vm.current
        ? [
            _c("p", { staticClass: "info__campaign" }, [
              _vm._v(_vm._s(_vm.campaignName(_vm.current))),
            ]),
            _vm.infoRows.length
              ? _c(
                  "div",
                  { staticClass: "info__grid" },
                  _vm._l(_vm.infoRows, function (row) {
                    return _c(
                      "div",
                      { key: row.label, staticClass: "info__row" },
                      [
                        _c("span", { staticClass: "info__key" }, [
                          _vm._v(_vm._s(row.label)),
                        ]),
                        _c("span", { staticClass: "info__value" }, [
                          _vm._v(_vm._s(row.value)),
                        ]),
                      ]
                    )
                  }),
                  0
                )
              : _vm._e(),
            _vm.campaign.objective
              ? _c("div", { staticClass: "info__block" }, [
                  _c("div", { staticClass: "info__label" }, [
                    _vm._v(_vm._s(_vm.$t("influencer_panel.info_objective"))),
                  ]),
                  _c("p", { staticClass: "info__text" }, [
                    _vm._v(_vm._s(_vm.campaign.objective)),
                  ]),
                ])
              : _vm._e(),
            _vm.campaign.rules
              ? _c("div", { staticClass: "info__block" }, [
                  _c("div", { staticClass: "info__label" }, [
                    _vm._v(_vm._s(_vm.$t("influencer_panel.rules"))),
                  ]),
                  _c("p", { staticClass: "info__text" }, [
                    _vm._v(_vm._s(_vm.campaign.rules)),
                  ]),
                ])
              : _vm._e(),
            _vm.campaign.dos
              ? _c("div", { staticClass: "info__block" }, [
                  _c("div", { staticClass: "info__label" }, [
                    _vm._v(_vm._s(_vm.$t("influencer_panel.info_dos"))),
                  ]),
                  _c("p", { staticClass: "info__text" }, [
                    _vm._v(_vm._s(_vm.campaign.dos)),
                  ]),
                ])
              : _vm._e(),
            _vm.campaign.donts
              ? _c("div", { staticClass: "info__block" }, [
                  _c("div", { staticClass: "info__label" }, [
                    _vm._v(_vm._s(_vm.$t("influencer_panel.info_donts"))),
                  ]),
                  _c("p", { staticClass: "info__text" }, [
                    _vm._v(_vm._s(_vm.campaign.donts)),
                  ]),
                ])
              : _vm._e(),
            _vm.mentions.length
              ? _c("div", { staticClass: "info__block" }, [
                  _c("div", { staticClass: "info__label" }, [
                    _vm._v(_vm._s(_vm.$t("influencer_panel.info_mentions"))),
                  ]),
                  _c(
                    "div",
                    { staticClass: "info__chips" },
                    _vm._l(_vm.mentions, function (mention) {
                      return _c(
                        "b-badge",
                        { key: mention, attrs: { variant: "light-primary" } },
                        [_vm._v("@" + _vm._s(mention))]
                      )
                    }),
                    1
                  ),
                ])
              : _vm._e(),
            _vm.campaign.disclosure_tag
              ? _c(
                  "div",
                  { staticClass: "info__block" },
                  [
                    _c("div", { staticClass: "info__label" }, [
                      _vm._v(_vm._s(_vm.$t("influencer_panel.disclosure_tag"))),
                    ]),
                    _c("b-badge", { attrs: { variant: "light-warning" } }, [
                      _vm._v(_vm._s(_vm.campaign.disclosure_tag)),
                    ]),
                  ],
                  1
                )
              : _vm._e(),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }